import store from '@/app/store/store';
import HELPER from '@/app/utils/HELPER';
import { postMessageToParent } from '@/app/utils/helpers';
import { app } from '@/store';

export const useListenMessageTriggerSave = () => {
  const isTriggerSave = ref(false);
  const handleSave = () => {
    document.getElementById('gf-save')?.click();
  };

  const listenMessage = (event: MessageEvent) => {
    try {
      const { data } = event;
      if (data.type === 'modalSavePage') {
        HELPER.showNotify('Saving...', 'info', 1000);
        isTriggerSave.value = true;
        handleSave();
      }
    } catch {
      isTriggerSave.value = false;
    }
  };

  const builderInIframeListener = () => {
    window.addEventListener('message', listenMessage);
  };

  const removeBuilderInIframeListener = () => {
    window.removeEventListener('message', listenMessage);
  };

  onMounted(() => {
    builderInIframeListener();
    store.onChange('__isSaved', (value) => {
      const isSaveDone = value && !app.$store.getters['sidebar/PRESET_IS_EDITED'];
      postMessageToParent({ type: isSaveDone ? 'saveDone' : 'pageChanged' });
    });
  });

  onUnmounted(() => {
    removeBuilderInIframeListener();
  });
};
